import React, { ReactElement } from 'react';
import TableCell from '../../../../components/table-cell/table-cell.component';
import Checkbox from '../../../../components/checkbox/checkbox.component';
import LongClickTableRow from '../../../../components/long-click-table-row/long-click-table-row.component';
import FilteredCell from '../../../../components/filtered-cell/filtered-cell.component';
import VisibleCell from '../../../../components/visible-cell/visible-cell.component';
import DealParticipantRowForm from '../deal-participant-row-form/deal-participant-row-form.component';
import useScreenSmall from '../../../../hooks/use-screen-small';

const DealParticipantRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_PREFIX_CHECKBOX_EXPORT_CARD: string = 'checkbox-export-card';

  const {
    isActive,
    isInlineSaving,
    isSaveDisabled,
    isSaving,
    isSelected,
    isEditMode,
    isSelectMode,
    isCustomizeMode,
    isNewDeal,
    dealId,
    inputRefs,
    currentUser,
    dealParticipantIndex,
    dealParticipantItem,
    dealParticipantNewItems,
    ndaFile,
    tableName,
    tableColumnSettings,
    tableDealParticipantListFields,
    contactPersonList,
    contactNotParticipantList,
    accessLevelList,
    dealParticipantGroupList,
    permissionList,
    onRowClick,
    onLongClick,
    onInlineSave,
    onInlineCancel,
    onContactChange,
    onNdaFileChange,
    onNdaFileDelete,
    onContactPersonSearch,
    onContactPersonSearchClose,
    onContactNotParticipantSearch,
    onContactNotParticipantSearchClose,
  } = props;

  const isSmallScreen: boolean = useScreenSmall();

  return (
    isEditMode && isActive ? (
      <DealParticipantRowForm
        isActive={isActive}
        isSaving={isSaving}
        isSaveDisabled={isSaveDisabled}
        isInlineSaving={isInlineSaving}
        inputRefs={inputRefs}
        tableName={tableName}
        tableColumnSettings={tableColumnSettings}
        currentUser={currentUser}
        dealId={dealId}
        dealParticipantIndex={dealParticipantIndex}
        dealParticipantData={dealParticipantItem}
        dealParticipantNewItems={dealParticipantNewItems}
        ndaFile={ndaFile}
        contactPersonList={contactPersonList}
        contactNotParticipantList={contactNotParticipantList}
        dealParticipantGroupList={dealParticipantGroupList}
        accessLevelList={accessLevelList}
        onInlineSave={onInlineSave}
        onInlineCancel={onInlineCancel}
        onContactChange={onContactChange}
        onNdaFileChange={onNdaFileChange}
        onNdaFileDelete={onNdaFileDelete}
        onContactPersonSearch={onContactPersonSearch}
        onContactPersonSearchClose={onContactPersonSearchClose}
        onContactNotParticipantSearch={onContactNotParticipantSearch}
        onContactNotParticipantSearchClose={onContactNotParticipantSearchClose}
      />
    ) : (
      <LongClickTableRow
        isActive={isSelected}
        isButton={!isCustomizeMode}
        onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onRowClick(event, dealParticipantItem);
        }}
        onLongClick={(): void => {
          onLongClick(dealParticipantItem.id);
        }}
      >
        {
          isSelectMode && (
            <TableCell isSticky isStickyLeft>
              <Checkbox
                isChecked={isSelected}
                withNoPadding={!isSmallScreen}
                id={`${ID_PREFIX_CHECKBOX_EXPORT_CARD}-${dealParticipantItem.id}`}
              />
            </TableCell>
          )
        }
        {
          tableDealParticipantListFields.map((tableField: TableField): ReactElement | boolean => (
            <VisibleCell
              isEditMode={isEditMode || isNewDeal}
              key={tableField.id}
              tableField={tableField}
              permissionList={permissionList}
            >
              {
                !!tableField.component && (
                  !tableField.isNotFiltered ? (
                    <FilteredCell tableName={tableName} columnName={tableField.name} currentUser={currentUser}>
                      {tableField.component(dealParticipantItem)}
                    </FilteredCell>
                  ) : (
                    tableField.component(dealParticipantItem)
                  )
                )
              }
            </VisibleCell>
          ))
        }
      </LongClickTableRow>
    )
  );
});

export default DealParticipantRow;
